import NavLink from 'next/link';
import {useContext} from 'react';

import IconNoAccessWarning from '@/public/icons/plusInBorderdCircle.svg';
import {NEW_POSITION} from '@/src/jobPortal/common/containers/SinglePositionBootstrap';
import RouteContext from '@/src/routes/utils/RouteContext';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button, Text} from '@/src/ui';

import css from '../styles/EmptyDataWithLink.module.css';

const EmptyDataWithLink = () => {
  // @ts-ignore
  const {JOB_PORTAL_MY_POSITION_EDIT} = useContext(RouteContext);

  return (
    <div className={css.withoutData}>
      <div className={css.borderIcon}>
        <div className={css.roundCardIcon}>
          <IconNoAccessWarning />
        </div>
      </div>
      <Text fontSize={Text.FONT_SIZE.SIZE_16} color={Text.COLOR.GREY}>
        <TextLocal id={'job-portal.empty-data-with-link'} />
      </Text>
      <div className={css.link}>
        <NavLink href={JOB_PORTAL_MY_POSITION_EDIT.getLink(NEW_POSITION)}>
          <Button
            color={Button.COLOR.SECONDARY}
            height={Button.HEIGHT.SMALL}
            border={Button.BORDER.BOLD}
          >
            <a>
              + <TextLocal id={'job-portal.add-positions'} />
            </a>
          </Button>
        </NavLink>
      </div>
    </div>
  );
};

export default EmptyDataWithLink;
